export default __webpack_public_path__ + "static/media/bell.c2e3ff6d.svg";